import React from 'react';
import { FileCheck, AlertTriangle, RefreshCw, Scale, ShieldCheck, Mail, Phone, MapPin } from 'lucide-react';

export default function TermsAndConditions() {
  return (
    <div style={{ background: '#F8FAF7', minHeight: '100vh', fontFamily: "'DM Sans', sans-serif", paddingBottom: '4rem' }}>
      {/* Header Banner */}
      <div style={{
        background: '#084734',
        color: 'white',
        padding: '4rem 2rem',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div style={{
          position: 'absolute',
          top: '-50px',
          right: '-50px',
          width: '250px',
          height: '250px',
          borderRadius: '50%',
          background: 'rgba(206, 241, 123, 0.08)',
          pointerEvents: 'none'
        }} />
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            background: 'rgba(206, 241, 123, 0.15)',
            border: '1px solid rgba(206, 241, 123, 0.3)',
            padding: '6px 16px',
            borderRadius: '50px',
            color: '#CEF17B',
            fontSize: '0.85rem',
            fontWeight: '700',
            marginBottom: '1rem'
          }}>
            <FileCheck size={16} color="#CEF17B" /> Terms of Service Agreement
          </div>
          <h1 style={{ fontSize: '2.5rem', fontWeight: '900', margin: '0 0 1rem 0', letterSpacing: '-0.5px' }}>
            Terms & Conditions
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.85)', fontSize: '1.05rem', lineHeight: '1.6', margin: 0 }}>
            Effective Date: July 29, 2026 • TurfX Sports Booking Platform
          </p>
        </div>
      </div>

      {/* Main Content Container */}
      <div style={{ maxWidth: '900px', margin: '-2rem auto 0 auto', padding: '0 1.5rem' }}>
        <div style={{
          background: 'white',
          borderRadius: '24px',
          padding: '3rem',
          boxShadow: '0 10px 40px rgba(0,0,0,0.06)',
          border: '1.5px solid #EEF2E6'
        }}>
          {/* Agreement to Terms */}
          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.4rem', fontWeight: '800', color: '#084734', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Scale size={22} color="#084734" /> 1. Agreement to Terms & Eligibility
            </h2>
            <p style={{ color: '#475569', lineHeight: '1.8', fontSize: '1rem' }}>
              By accessing or using the <strong>TurfX</strong> platform, web application, or mobile application (operated by <strong>MetaQode Technologies Pvt. Ltd.</strong>), you agree to be legally bound by these Terms and Conditions. This contract is valid and enforceable under the Information Technology Act, 2000 (India).
            </p>
          </section>

          <hr style={{ border: 'none', borderTop: '1px dashed #E2E8F0', margin: '2rem 0' }} />

          {/* Platform Commission & Fees */}
          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.4rem', fontWeight: '800', color: '#084734', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <ShieldCheck size={22} color="#084734" /> 2. Platform Commission & Fee Structure
            </h2>
            <div style={{ background: '#FAFCF8', border: '1.5px solid #EEF2E6', borderRadius: '16px', padding: '1.5rem', marginTop: '1rem' }}>
              <ul style={{ color: '#475569', lineHeight: '1.8', fontSize: '0.95rem', margin: 0, paddingLeft: '1.2rem' }}>
                <li><strong>Customer Booking Commission:</strong> TurfX charges a transparent <strong>5% platform fee / convenience commission</strong> (+ applicable GST) on every customer slot reservation to cover real-time court availability locks, encrypted payment processing, and SMS/WhatsApp notifications.</li>
                <li><strong>Vendor Commercial Commission:</strong> TurfX retains a <strong>5% merchant platform fee / commission</strong> (+ 18% GST on platform fee) from the gross court booking fee on all bookings fulfilled through TurfX, deducted automatically prior to bank settlement disbursal.</li>
                <li><strong>Tournament Entry & Host Fees:</strong> For sports tournaments hosted on TurfX, players/teams pay the designated entry fee plus a <strong>5% platform tournament facilitation commission</strong>. For tournament organizers, a <strong>5% facilitation fee</strong> is deducted from total tournament entry collections to manage digital brackets, live fixtures, referee scorecards, and verified prize pool payouts.</li>
              </ul>
            </div>
          </section>

          <hr style={{ border: 'none', borderTop: '1px dashed #E2E8F0', margin: '2rem 0' }} />

          {/* Bookings & Slot Rules */}
          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.4rem', fontWeight: '800', color: '#084734', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <FileCheck size={22} color="#084734" /> 3. Booking Rules & Venue Conduct
            </h2>
            <ul style={{ color: '#475569', lineHeight: '1.8', fontSize: '1rem', paddingLeft: '1.5rem' }}>
              <li><strong>Reservation Guarantee:</strong> Slots are confirmed only upon successful payment authorization or verified booking QR pass.</li>
              <li><strong>Punctuality:</strong> Players must arrive 10 minutes prior to slot start time. Late arrival does not extend booked slot duration.</li>
              <li><strong>Footwear Guidelines:</strong> Non-marking sports shoes or turf stud shoes must be worn on artificial turfs and wooden courts as instructed by venue managers. Metal spikes are strictly prohibited.</li>
              <li><strong>Zero Tolerance:</strong> Smoking, consumption of alcohol, violence, or damage to venue property is strictly prohibited and subject to immediate ground eviction.</li>
            </ul>
          </section>

          <hr style={{ border: 'none', borderTop: '1px dashed #E2E8F0', margin: '2rem 0' }} />

          {/* Cancellation & Reschedule Policy */}
          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.4rem', fontWeight: '800', color: '#084734', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <RefreshCw size={22} color="#084734" /> 4. Cancellation, Reschedule & Refunds
            </h2>
            <div style={{ background: '#FAFCF8', border: '1px solid #EEF2E6', borderRadius: '16px', padding: '1.5rem', marginTop: '1rem' }}>
              <ul style={{ color: '#475569', lineHeight: '1.8', fontSize: '0.95rem', margin: 0, paddingLeft: '1.2rem' }}>
                <li><strong>Within 1 Hour of Booking:</strong> Base booking amount refunded to your TurfX wallet or source account (Platform fee & GST retained by platform).</li>
                <li><strong>More than 6 Hours Before Slot:</strong> Full base booking amount refunded to your TurfX wallet.</li>
                <li><strong>Within 6 Hours of Slot:</strong> Non-refundable (50% is paid directly to the venue owner as operational loss compensation).</li>
                <li><strong>Reschedule Limit:</strong> A booking can be rescheduled <strong>once</strong> subject to court availability and prior notice.</li>
              </ul>
            </div>
          </section>

          <hr style={{ border: 'none', borderTop: '1px dashed #E2E8F0', margin: '2rem 0' }} />

          {/* Limitation of Liability */}
          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.4rem', fontWeight: '800', color: '#084734', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <AlertTriangle size={22} color="#084734" /> 5. Intermediary Status & Limitation of Liability
            </h2>
            <p style={{ color: '#475569', lineHeight: '1.8', fontSize: '1rem' }}>
              TurfX provides technology facilitation connecting players and independent venue operators under Section 79 of the Information Technology Act, 2000. Physical sports activities entail natural risk of injury. TurfX is not liable for personal bodily injuries, lost personal belongings, or adverse weather disruptions occurring at third-party sports venues.
            </p>
          </section>

          <hr style={{ border: 'none', borderTop: '1px dashed #E2E8F0', margin: '2rem 0' }} />

          {/* Contact Section */}
          <section>
            <h2 style={{ fontSize: '1.4rem', fontWeight: '800', color: '#084734', marginBottom: '1rem' }}>
              5. Questions & Legal Inquiries
            </h2>
            <p style={{ color: '#475569', lineHeight: '1.8', fontSize: '1rem' }}>
              If you have any questions regarding these Terms and Conditions, please contact us:
            </p>
            <div style={{ background: '#084734', color: 'white', borderRadius: '16px', padding: '1.5rem', display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '1rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}><Mail size={18} color="#CEF17B" /> <span>support@metaqode.co.in</span></div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}><Phone size={18} color="#CEF17B" /> <span>+91 9980998199</span></div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}><MapPin size={18} color="#CEF17B" /> <span>MetaQode Technologies Pvt. Ltd., Chitradurga - 577501, Karnataka, India</span></div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
